import { useTranslation } from '@frontend/i18n';
import { Button, ButtonBar } from '@frontend/design-system';
import { AudienceTray } from '../audience-tray/audience-tray';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  cancelCreateList: () => void;
};

export const UploadViewFooter = ({ cancelCreateList }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix } = useAudienceTray();

  return (
    <AudienceTray.Footer hideBorder>
      <AudienceTray.Footer.ActionsBar>
        <ButtonBar css={{ justifyContent: 'flex-end', padding: 0 }}>
          <Button
            onClick={cancelCreateList}
            size='large'
            variant='secondary'
            trackingId={`${trackingIdPrefix}-contacts-upload-cancel-btn`}
          >
            {t('Cancel')}
          </Button>
        </ButtonBar>
      </AudienceTray.Footer.ActionsBar>
    </AudienceTray.Footer>
  );
};
